import React from 'react'

const Anchor = ({
  href,
  src,
  alt,
  target = '_blank',
  // objectFit = 'contain',
  // placeholder = 'blurred',
  className
}) => {
  return (
    <a href={href} target={target} rel="noreferrer">
      <img
        src={src}
        alt={alt}
        title={alt}
        className={`h-6 w-6 rounded-full hover:scale-105 hover:drop-shadow-md md:h-8 md:w-8 ${className}`}
        // objectFit={objectFit}
        // placeholder={placeholder}
        // loading="eager"
      />
    </a>
  )
}

export default Anchor
